import { render, staticRenderFns } from "./StudentTestViewer.vue?vue&type=template&id=40064a36&scoped=true&lang=pug&"
import script from "./StudentTestViewer.vue?vue&type=script&lang=ts&"
export * from "./StudentTestViewer.vue?vue&type=script&lang=ts&"
import style0 from "./StudentTestViewer.vue?vue&type=style&index=0&id=40064a36&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40064a36",
  null
  
)

export default component.exports